import {Component, HostBinding, OnInit} from '@angular/core';
import {FeatureCreateCommand, FeaturesDataService} from '../services/features.data.service';
import {GeneralService, SnackbarService} from 'app/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Location} from '@angular/common';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'sh-features-create',
    templateUrl: './features-create.component.html',
    styleUrls: ['./features-create.component.scss']
})
export class FeaturesCreateComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    creatingForm: FormGroup;
    fields: FormArray;
    fieldId = 0;

    isSaving = false;

    types = ['Text', 'Boolean', 'Select'];

    navigationBackArray = ['metadata', 'settings', 'features'];

    constructor(
        public dataService: FeaturesDataService,
        public generalService: GeneralService,
        private featuresDataService: FeaturesDataService,
        private formBuilder: FormBuilder,
        private snackBar: SnackbarService,
        private _location: Location,
    ) {
    }

    ngOnInit(): void {
        this.creatingForm = this.formBuilder.group({
            name: ['', Validators.required],
            type: ['Text', Validators.required],
            possibleValues: this.formBuilder.array([])
        });
    }

    onSubmit() {
        if (!this.creatingForm.valid) {
            this.snackBar.info('Nie można zapisać zmian. W formularzu znajdują się błędy.');
            return;
        }
        const data = this.createData();
        this.isSaving = true;

        this.dataService.create(data)
            .subscribe(
                res => console.log(res),
                err => this.featureError(err),
                () => this.featureCreated()
            );
    }

    private createData(): FeatureCreateCommand {
        const data = this.creatingForm.value;
        if (data.type === 'Select') {
            data.possibleValues = data.possibleValues.map(possibleValue => (possibleValue.name));
        } else {
            data.possibleValues = undefined;
        }
        return data;
    }

    createField() {
        this.fieldId++;
        return this.formBuilder.group({
            name: ['', Validators.required],
            id: this.fieldId
        }, {validator: this.uniqueNames.bind(this)});
    }

    uniqueNames(control: AbstractControl) {
        const name = control.get('name').value;
        if (control.get('name').valid) {
          const isNameDuplicate =
              this.creatingForm.get('possibleValues')['controls']
                  .map(field => field.value.name)
                  .filter(value => value === name).length > 1;
          if (isNameDuplicate) {
            control.get('name').setErrors({duplicated: true});
          }
        }
    }

    addField() {
        this.fields = this.creatingForm.get('possibleValues') as FormArray;
        this.fields.push(this.createField());
    }

    removeField(fieldIndex: number) {
        this.fields = this.creatingForm.get('possibleValues') as FormArray;
        this.fields.removeAt(
            this.fields.value.findIndex(field => field.id === fieldIndex)
        );
    }

    private featureCreated(): void {
        this.snackBar.info('Cecha została utworzona.');
        this._location.back();
    }

    private featureError(err: HttpErrorResponse) {
        this.isSaving = false;
        if (err.status !== 400) {
            this.snackBar.info('Podczas zapisywania wystąpił błąd.');
        } else {
            this.snackBar.info('Cecha o takiej nazwie już istnieje.');
        }
    }

    changeType() {
        if (this.creatingForm.value.type === 'Select') {
            this.creatingForm.get('possibleValues').setValue([this.addField()]);
        } else {
            this.creatingForm.get('possibleValues').setValue([]);
        }
    }

    public navigationBack(): void {
        this.generalService.navigateTo(this.navigationBackArray);
    }
}
